import React, { Component } from "react";

export class Team extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data
    }
  }
  render() {
    return (
      <div 
        id="team"
        className="text-center"
        style={{background: 'url(img/imagenes_llucmajor/medico_grande.jpg) center center no-repeat'}}
      >
        <div className="container">
          <div className="col-md-8 col-md-offset-2 section-title">
            <h2>
            {this.props.data.temporalDays}:<br/>
            {this.props.data.temporalHours}
            <br/><br/>
            {this.props.data.firstDays}:<br/>
            {this.props.data.firstHours}
            <br/><br/>
            {this.props.data.secondtDays}:
            {this.props.data.secondtHours}
            </h2>
            
          </div>
          <div id="row">
            
          </div>
        </div>
      </div>
    );
  }
}

export default Team;
